export default class Pricelist {
    constructor() {
        this.selectors = {
            trigger: '[data-pricelist-trigger]',
            wrapper: '[data-pricelist-wrapper]',
            target:  '[data-pricelist-target]'
        };

        this.init();
    }

    init() {
        var self = this,
        $triggers = $( self.selectors.trigger ),
        $wrappers = $( self.selectors.wrapper );

        $triggers.on( 'change', function( e ) {
            var $this   = $( this ),
            wrapperID   = $this.attr( 'data-pricelist-trigger' ),
            $wrapper    = $wrappers.filter( '[data-pricelist-wrapper="' + wrapperID + '"]' ),
            currentVal  = $this.val(),
            $pricelists = $wrapper.find( self.selectors.target );

            $pricelists.removeClass( 'active' );
            $pricelists.filter( '#' + currentVal ).addClass( 'active' );            
        } );
    }
}